import React, { ReactNode } from 'react';
import {
    ColorDSD,
    ColorHex,
    Police,
    Tooltip,
    ToolTipPlacement,
    Typography,
    Variant
} from '../../styles';
import { Box } from '@material-ui/core';

export interface TexteAvecInfoBulleProps {
    label: string | ReactNode;
    labelVariant?: Variant;
    labelPolice?: Police;
    labelColor?: ColorDSD | ColorHex;
    labelInfoBulle: string | ReactNode;
    labelInfoBullePlacement?: ToolTipPlacement;
    labelHorsEcranInfoBulle: string;
    labelClass?: string;
    iconColor?: ColorDSD;
    iconColorCustom?: ColorHex;
    isCentreeDansContainer?: boolean;
    isLabelEtIconeCentres?: boolean;
    dataTestId?: string;
    onToolTipActive?: () => void;
}

export const TexteAvecInfoBulle: React.FC<TexteAvecInfoBulleProps> = ({
    label,
    labelVariant = Variant.p,
    labelPolice = Police.normal,
    labelColor,
    labelInfoBulle,
    labelInfoBullePlacement,
    labelHorsEcranInfoBulle,
    labelClass,
    isCentreeDansContainer = false,
    isLabelEtIconeCentres = true,
    dataTestId,
    onToolTipActive
}) => {
    return (
        <Box
            display="flex"
            flexWrap="nowrap"
            alignItems={isLabelEtIconeCentres ? 'center' : 'flex-start'}
            justifyContent={isCentreeDansContainer ? 'center' : 'flex-start'}
        >
            <Typography
                variant={labelVariant}
                police={labelPolice}
                color={labelColor}
                marginBottom={'0rem'} // si on met une marge l'infobulle et le texte ne sont pas centrés
                className={labelClass}
            >
                {label}
            </Typography>
            <Box paddingLeft="0.5rem" />
            <Tooltip
                label={labelInfoBulle}
                description={labelHorsEcranInfoBulle}
                placement={labelInfoBullePlacement}
                dataTestId={dataTestId}
                onClick={onToolTipActive}
            />
        </Box>
    );
};
